var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplainerPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88045 13.6368L19.5 5.7735L33.1195 13.6368V29.3632L19.5 37.2265L5.88045 29.3632V13.6368Z",
    fill: "#100F2E",
    stroke: "#100F2E",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31C16.6833 30.4167 14.7708 29.0875 13.2625 27.0125C11.7542 24.9375 11 22.6333 11 20.1V14L19 11L27 14V20.1C27 21.5167 26.7583 22.8792 26.275 24.1875C25.7917 25.4958 25.1 26.65 24.2 27.65L21 24.45C20.7 24.6333 20.3792 24.7708 20.0375 24.8625C19.6958 24.9542 19.35 25 19 25C17.9 25 16.9583 24.6083 16.175 23.825C15.3917 23.0417 15 22.1 15 21C15 19.9 15.3917 18.9583 16.175 18.175C16.9583 17.3917 17.9 17 19 17C20.1 17 21.0417 17.3917 21.825 18.175C22.6083 18.9583 23 19.9 23 21C23 21.3667 22.9542 21.7208 22.8625 22.0625C22.7708 22.4042 22.6333 22.7333 22.45 23.05L23.95 24.55C24.2833 23.8667 24.5417 23.15 24.725 22.4C24.9083 21.65 25 20.8833 25 20.1V15.375L19 13.125L13 15.375V20.1C13 22.1167 13.5667 23.95 14.7 25.6C15.8333 27.25 17.2667 28.35 19 28.9C19.4333 28.7667 19.8458 28.5958 20.2375 28.3875C20.6292 28.1792 21.0167 27.9333 21.4 27.65L22.8 29.05C22.25 29.5 21.6542 29.8917 21.0125 30.225C20.3708 30.5583 19.7 30.8167 19 31ZM19 23C19.55 23 20.0208 22.8042 20.4125 22.4125C20.8042 22.0208 21 21.55 21 21C21 20.45 20.8042 19.9792 20.4125 19.5875C20.0208 19.1958 19.55 19 19 19C18.45 19 17.9792 19.1958 17.5875 19.5875C17.1958 19.9792 17 20.45 17 21C17 21.55 17.1958 22.0208 17.5875 22.4125C17.9792 22.8042 18.45 23 19 23Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplainerPolicy);
export default __webpack_public_path__ + "static/media/explainer-policy.25199ca56c015690273fea372615ad8f.svg";
export { ForwardRef as ReactComponent };